import { render, staticRenderFns } from "./Estimacion.vue?vue&type=template&id=31a8da36"
import script from "./Estimacion.vue?vue&type=script&lang=js"
export * from "./Estimacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports